import React, { useRef, useState } from "react";
import Axios from "axios";
// import { toast, ToastContainer } from "react-toastify";

const ALLOWED_LOGO_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];
const MAX_LOGO_SIZE = 500 * 1024; // 500 KB
const MIN_QUOTE_LENGTH = 20;
const MAX_QUOTE_LENGTH = 400;
const MAX_NAME_LENGTH = 30;

const ClientTestimonialForm = () => {
  const [clientName, setClientName] = useState("");
  const [clientRole, setClientRole] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [industry, setIndustry] = useState("");
  const [clientQuote, setClientQuote] = useState("");
  const [clientLogo, setClientLogo] = useState(null);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!clientName.trim()) {
      newErrors.clientName = "Full name is required.";
    } else if (clientName.trim().length < 2) {
      newErrors.clientName = "Full name must be at least 2 characters.";
    } else if (clientName.trim().length > MAX_NAME_LENGTH) {
      newErrors.clientName = `Full name cannot exceed ${MAX_NAME_LENGTH} characters.`;
    }

    if (!clientRole.trim()) {
      newErrors.clientRole = "Job title / designation is required.";
    }

    if (!companyName.trim()) {
      newErrors.companyName = "Company name is required.";
    }

    if (!clientQuote.trim()) {
      newErrors.clientQuote = "Please share your experience.";
    } else if (clientQuote.trim().length < MIN_QUOTE_LENGTH) {
      newErrors.clientQuote = `Please write at least ${MIN_QUOTE_LENGTH} characters.`;
    } else if (clientQuote.length > MAX_QUOTE_LENGTH) {
      newErrors.clientQuote = `Testimonial cannot exceed ${MAX_QUOTE_LENGTH} characters.`;
    }

    if (!clientLogo) {
      newErrors.clientLogo = "Please upload your company logo.";
    } else if (!ALLOWED_LOGO_TYPES.includes(clientLogo.type)) {
      newErrors.clientLogo = "Only PNG, JPG, JPEG & WEBP files are allowed.";
    } else if (clientLogo.size > MAX_LOGO_SIZE) {
      newErrors.clientLogo = "Image size must be less than 500 KB.";
    }

    if (!consentChecked) {
      newErrors.consent = "Please accept the consent statement.";
    }

    setErrors(newErrors);

    if (newErrors.consent) {
      // toast.error(newErrors.consent);
    }

    return Object.keys(newErrors).length === 0;
  };

  const clearForm = () => {
    setClientName("");
    setClientRole("");
    setCompanyName("");
    setIndustry("");
    setClientQuote("");
    setClientLogo(null);
    setConsentChecked(false);
    setErrors({});

    const fileInput = document.getElementById("clientLogo");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const uploadClient = async () => {
    if (!validateForm()) {
      // toast.error("Please fix the highlighted fields.");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("client_name", clientName);
      formData.append("client_role", clientRole);
      formData.append("company_name", companyName);
      formData.append("industry", industry);
      formData.append("client_quote", clientQuote);
      formData.append("client_logo", clientLogo);

      const res = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}php/submit_testimonial.php`,
        formData,
      );

      if (res.data.success) {
        clearForm();
        setSubmitted(true);
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
      // toast.error("Submission failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
body{
    background:#f4f7fb;
}

.primary-btn {
  color: #fff;
  background-color: #009bd4;
  border-color: #009bd4;
}
.primary-btn:hover {
  color: #fff;
  background-color: #17171d;
  border-color: #17171d;
}

.ctf-page{
    min-height:100vh;
    display:flex;
    justify-content:center;
    align-items:center;
    padding:40px 12px;
    background:#f4f7fb;
    overflow-y:auto;
}

.ctf-card{
    width:100%;
    max-width:460px;
    background:#fff;
    border-radius:18px;
    overflow:hidden;
    box-shadow:0 10px 30px rgba(15,23,42,.08);
}

.ctf-header{
    padding:22px 20px 14px;
    text-align:center;
    border-bottom:1px solid #edf1f6;
}

.ctf-company-logo{
    width:90px;
    margin:auto;
    display:block;
    margin-bottom:12px;
}

.ctf-title{
    font-size:19px;
    font-weight:700;
    color:#1d3557;
    margin:0;
}

.ctf-form{
    padding:18px 20px 24px;
}

.ctf-field{
    display:flex;
    flex-direction:column;
    margin-bottom:16px;
}

.ctf-field label{
    font-weight:600;
    color:#26364d;
    margin-bottom:6px;
    font-size:13px;
}

.form-control{
    height: 30px !important;
}

.ctf-field .form-control{
    border-radius:10px;
    border:1px solid #d9e2ec;
    min-height:44px;
    padding:10px 14px;
    font-size:14.5px;
    transition:.2s;
    box-shadow:none;
}

.ctf-field textarea.form-control{
    min-height:110px;
    resize:vertical;
}

.ctf-field .form-control:focus{
    border-color:#009BD4;
    box-shadow:0 0 0 3px rgba(0,155,212,.12);
}

.ctf-field .form-control.is-invalid{
    border-color:#dc3545;
}

.ctf-error{
    color:#dc3545;
    font-size:12px;
    margin-top:4px;
    line-height:1.4;
}

.ctf-field-row{
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:12px;
}

.ctf-char-count{
    text-align:right;
    margin-top:4px;
    font-size:12px;
    color:#9aa6b2;
}

.ctf-photo-row{
    display:flex;
    align-items:center;
    gap:12px;
}

.ctf-photo-avatar{
    width:52px;
    height:52px;
    border-radius:12px;
    object-fit:contain;
    background:#f8fbff;
    border:1px solid #dbe4ee;
    flex:none;
    padding:4px;
}

.ctf-photo-btn{
    border:1px solid #d9e2ec;
    background:#f8fbff;
    color:#009BD4;
    border-radius:10px;
    padding:10px 14px;
    font-size:13.5px;
    font-weight:600;
    cursor:pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:8px;
    flex:1;
}

.ctf-photo-btn:hover{
    background:#eef7fc;
}

.ctf-photo-btn.is-invalid{
    border-color:#dc3545;
    color:#dc3545;
}

.ctf-upload-note{
    color:#8a97a6;
    font-size:11.5px;
    margin-top:6px;
}

.ctf-consent-box{
    background:#f8fafc;
    border:1px solid #e5edf6;
    border-radius:10px;
    padding:14px;
    color:#5b6778;
    line-height:1.5;
    font-size:12.5px;
    margin-bottom:16px;
}

.ctf-consent-row{
    display:flex;
    align-items:flex-start;
    margin-top:10px;
    gap:8px;
}

.ctf-consent-row label{
    margin:0;
    cursor:pointer;
    color:#1f2937;
    font-weight:500;
    font-size:12.5px;
}

.ctf-required{
    color:#dc3545;
}

.ctf-submit button{
    width:100%;
    height:48px;
    border:none;
    border-radius:12px;
    font-size:15.5px;
    font-weight:700;
}

.ctf-thankyou{
    text-align:center;
    padding:36px 20px 44px;
}

.ctf-thankyou i{
    font-size:48px;
    color:#198754;
    margin-bottom:14px;
}

.ctf-thankyou h2{
    font-weight:700;
    font-size:17px;
    margin-bottom:10px;
}

.ctf-thankyou p{
    color:#6c757d;
    line-height:1.6;
    font-size:13.5px;
    margin:0;
}

@media(max-width:420px){
    .ctf-field-row{
        grid-template-columns:1fr;
        gap:0;
    }
}

`}</style>

      <div className="ctf-page">
        <div className="ctf-card">
          {submitted ? (
            <>
              <div className="ctf-header">
                <img
                  src="/images/ange_gulf_logo.png"
                  alt="Angel Gulf Jobs"
                  className="ctf-company-logo"
                />
              </div>

              <div className="ctf-thankyou">
                <h1 className="ctf-title mb-4">Thanks for your feedback!</h1>
                <i className="fa fa-check-circle"></i>
                {/* <h2>Testimonial submitted</h2>
                <p>
                  Your testimonial will appear on our site once it's
                  approved.
                </p> */}
              </div>
            </>
          ) : (
            <>
              <div className="ctf-header">
                <img
                  src="/images/ange_gulf_logo.png"
                  alt="Angel Gulf Jobs"
                  className="ctf-company-logo"
                />
                <h1 className="ctf-title">Share Your Experience</h1>
              </div>

              <div className="ctf-form" ref={formRef}>
                {/* Name + Role */}
                <div className="ctf-field-row">
                  <div className="ctf-field">
                    <label>
                      Full Name <span className="ctf-required">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={MAX_NAME_LENGTH}
                      className={`form-control ${errors.clientName ? "is-invalid" : ""}`}
                      placeholder="Your full name"
                      value={clientName}
                      onChange={(e) => {
                        setClientName(e.target.value);
                        clearFieldError("clientName");
                      }}
                    />
                    {errors.clientName && (
                      <div className="ctf-error">{errors.clientName}</div>
                    )}
                  </div>

                  <div className="ctf-field">
                    <label>
                      Job Title <span className="ctf-required">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.clientRole ? "is-invalid" : ""}`}
                      placeholder="e.g. HR Manager"
                      value={clientRole}
                      onChange={(e) => {
                        setClientRole(e.target.value);
                        clearFieldError("clientRole");
                      }}
                    />
                    {errors.clientRole && (
                      <div className="ctf-error">{errors.clientRole}</div>
                    )}
                  </div>
                </div>

                {/* Company + Industry */}
                <div className="ctf-field-row">
                  <div className="ctf-field">
                    <label>
                      Company Name <span className="ctf-required">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.companyName ? "is-invalid" : ""}`}
                      placeholder="Company name"
                      value={companyName}
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                        clearFieldError("companyName");
                      }}
                    />
                    {errors.companyName && (
                      <div className="ctf-error">{errors.companyName}</div>
                    )}
                  </div>

                  <div className="ctf-field">
                    <label>Industry</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g. Oil & Gas"
                      value={industry}
                      onChange={(e) => setIndustry(e.target.value)}
                    />
                  </div>
                </div>

                {/* Logo — compact row, same treatment as reviewer photo */}
                <div className="ctf-field">
                  <label>
                    Company Logo <span className="ctf-required">*</span>
                  </label>

                  <div className="ctf-photo-row">
                    {clientLogo && (
                      <img
                        src={URL.createObjectURL(clientLogo)}
                        alt="Preview"
                        className="ctf-photo-avatar"
                      />
                    )}

                    <label
                      htmlFor="clientLogo"
                      className={`ctf-photo-btn ${errors.clientLogo ? "is-invalid" : ""}`}
                    >
                      <i className="fa fa-upload"></i>
                      {clientLogo ? "Change Logo" : "Upload Logo"}
                    </label>

                    <input
                      id="clientLogo"
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg,.webp"
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          setClientLogo(e.target.files[0]);
                          clearFieldError("clientLogo");
                        }
                      }}
                    />
                  </div>

                  <div className="ctf-upload-note">
                    PNG, JPG or WEBP, max 500 KB
                  </div>

                  {errors.clientLogo && (
                    <div className="ctf-error">{errors.clientLogo}</div>
                  )}
                </div>

                {/* Testimonial */}
                <div className="ctf-field">
                  <label>
                    Your Testimonial <span className="ctf-required">*</span>
                  </label>

                  <textarea
                    className={`form-control ${errors.clientQuote ? "is-invalid" : ""}`}
                    rows="5"
                    maxLength={MAX_QUOTE_LENGTH}
                    placeholder="Share your experience working with Angel Gulf Jobs..."
                    value={clientQuote}
                    onChange={(e) => {
                      setClientQuote(e.target.value);
                      clearFieldError("clientQuote");
                    }}
                  />

                  <div className="ctf-char-count">
                    {clientQuote.length} / {MAX_QUOTE_LENGTH}
                  </div>

                  {errors.clientQuote && (
                    <div className="ctf-error">{errors.clientQuote}</div>
                  )}
                </div>

                {/* Consent */}
                <div className="ctf-consent-box">
                  By submitting, I confirm this information is accurate and
                  may be used by Angel Gulf Jobs for marketing and
                  promotional purposes, subject to approval.
                  <div className="ctf-consent-row">
                    <input
                      type="checkbox"
                      id="consentCheckbox"
                      checked={consentChecked}
                      onChange={(e) => setConsentChecked(e.target.checked)}
                      style={{ marginTop: "3px", cursor: "pointer" }}
                    />
                    <label htmlFor="consentCheckbox">
                      I agree to the above.
                      <span className="ctf-required"> *</span>
                    </label>
                  </div>
                  {errors.consent && (
                    <div className="ctf-error" style={{ marginLeft: "22px" }}>
                      {errors.consent}
                    </div>
                  )}
                </div>

                <div className="ctf-submit">
                  <button
                    type="button"
                    className="btn primary-btn"
                    disabled={loading}
                    onClick={uploadClient}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane me-2"></i>
                        Submit Testimonial
                      </>
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* <ToastContainer position="bottom-center" autoClose={3000} /> */}
    </>
  );
};

export default ClientTestimonialForm;